<template>
  <div>
    <div class="box box-primary">
      <div style="border: 0px solid black; width:100%; padding: 10px">
        <div class="welcome" style="border: 0px solid red;">
          <row
            style="border:0px solid green;position: inherit;display:contents;width:100%;"
          >
            <div class="">
              <div class="panel with-nav-tabs panel-primary">
                <div class="panel-heading">
                  <ul class="nav nav-tabs">
                    <li class="active" @click="onSelectTab(1)">
                      <a href="#tab1primary" data-toggle="tab">{{
                        $t("service.service")
                      }}</a>
                    </li>
                    <li @click="onSelectTab(2)">
                      <a href="#tab2primary" data-toggle="tab">{{
                        $t("common.history")
                      }}</a>
                    </li>
                    <!-- <li @click="onSelectTab(3)">
                      <a href="#tab3primary" data-toggle="tab">{{
                        $t("service.serviceUnit")
                      }}</a>
                    </li> -->
                  </ul>
                </div>
                <div class="panel-body">
                  <div class="tab-content">
                    <div class="tab-pane fade in active" id="tab1primary">
                      <div style="padding: 10px; background: #e4e7e8">
                        <service-list ref="serviceList"/>
                      </div>
                    </div>
                    <div class="tab-pane fade" id="tab2primary">
                      <div style="padding: 10px; background: #e4e7e8">
                        <service-history ref="serviceGroup"/>
                      </div>
                    </div>
                    <!-- <div class="tab-pane fade" id="tab3primary">
                      <div style="padding: 10px; background: #e4e7e8">
                        <service-unit ref="serviceUnit"/>
                      </div>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </row>
        </div>
      </div>
    </div>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
  </div>
</template>
<script>
import utils from "@/lib/utils";
import { mapActions, mapGetters } from "vuex";
import Loading from "vue-loading-overlay";
import ServiceList from "./ApartmentServiceList";
import ServiceHistory from "./ServiceHistoryList"
// import ServiceGroup from "./ServiceGroup"
// import ServiceUnit from "./ServiceUnit"
import LTECoreAlert from "@/components/LTESnackBar.vue";

export default {
  components: {
    Loading,
    ServiceList,
    ServiceHistory,
    // ServiceGroup,
    // ServiceUnit,
    "lte-core-alert": LTECoreAlert
  },
  data: () => ({
    isLoading: false
  }),
  computed: {
    ...mapGetters([
      "GET_ACCOUNT_DATA",
      "GET_SNACK_BAR"
    ])
  },
  methods: {
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    onSelectTab: function(value) {
      switch (value) {
        case 1:
          this.$refs.serviceList.onCallbackData()
          break;
        case 2:
          this.$refs.serviceGroup.onCallbackData()
          break;
        case 3:
          this.$refs.serviceUnit.onCallbackData()
          break;
        default:
          break;
      }
    },
    ...mapActions([])
  },
  mounted() {}
};
</script>
<style scoped>
.panel.with-nav-tabs .panel-heading {
  padding: 5px 5px 0 5px;
}
.panel.with-nav-tabs .nav-tabs {
  border-bottom: none;
}
.panel.with-nav-tabs .nav-justified {
  margin-bottom: -1px;
}
/********************************************************************/
/*** PANEL PRIMARY ***/
.with-nav-tabs.panel-primary .nav-tabs > li > a,
.with-nav-tabs.panel-primary .nav-tabs > li > a:hover,
.with-nav-tabs.panel-primary .nav-tabs > li > a:focus {
  color: #fff;
}
.with-nav-tabs.panel-primary .nav-tabs > .open > a,
.with-nav-tabs.panel-primary .nav-tabs > .open > a:hover,
.with-nav-tabs.panel-primary .nav-tabs > .open > a:focus,
.with-nav-tabs.panel-primary .nav-tabs > li > a:hover,
.with-nav-tabs.panel-primary .nav-tabs > li > a:focus {
  color: #fff;
  background-color: #3071a9;
  border-color: transparent;
}
.with-nav-tabs.panel-primary .nav-tabs > li.active > a,
.with-nav-tabs.panel-primary .nav-tabs > li.active > a:hover,
.with-nav-tabs.panel-primary .nav-tabs > li.active > a:focus {
  color: #428bca;
  background-color: #fff;
  border-color: #428bca;
  border-bottom-color: transparent;
}
.with-nav-tabs.panel-primary .nav-tabs > li.dropdown .dropdown-menu {
  background-color: #428bca;
  border-color: #3071a9;
}
.with-nav-tabs.panel-primary .nav-tabs > li.dropdown .dropdown-menu > li > a {
  color: #fff;
}
.with-nav-tabs.panel-primary
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > li
  > a:hover,
.with-nav-tabs.panel-primary
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > li
  > a:focus {
  background-color: #3071a9;
}
.with-nav-tabs.panel-primary
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > .active
  > a,
.with-nav-tabs.panel-primary
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > .active
  > a:hover,
.with-nav-tabs.panel-primary
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > .active
  > a:focus {
  background-color: #4a9fe9;
}
.with-nav-tabs.panel-primary .panel-body {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/Service/ServiceTabs.vue